<template>
	<div class="root">
		<MeetingHeader/>
		<div class="container">
			<div class="banner">
				<div class="banner-left"><img class="banner-img" :src="store.HeadImage" alt=""></div>
				<div class="info">
					<div class="meeting-name">{{store.StoreName}}</div>
					<div class="meeting-desc">{{store.Address}}</div>
					<div class="features">
						<!-- <div class="feature">
							<img class="icon" src="@/assets/shmeeting/feature2.jpg" alt="">
							场地布置
						</div> -->
						<div class="feature">
							<img class="icon" src="@/assets/shmeeting/feature3.jpg" alt="">
							支持投影
						</div>
					</div>
				</div>
			</div>
			<div class="content">
				<div class='sh-date-picker-box'>
					<DatePicker type="date" placeholder="选择日期" style="width: 200px" size='large' v-model='date' @on-change='dateChange' :options='options'></DatePicker>	
				</div>
				<div class="row table-heads">
					<div class='row flex-4'>
						<div class="table-head flex-2">房间</div>
						<div class="row flex-3">
							<div class="table-head">功能</div>
							<div class="table-head">面积</div>
							<div class="table-head">容纳人数</div>
						</div>
						
					</div>
					<div class="table-head flex-3">注意事项</div>
					<div class="table-head flex-2">预约时间</div>
					<div class="table-head flex-2">租赁费用</div>
				</div>
				<loading v-if='loading'/>
				<template v-else-if='rooms.length'>
					<div class="table-body" v-for='item in rooms' :key='item.ID'>
						<div class="row room">
							<div class="room-item flex-4">
								<div class='flex-2 column'>
									<img class="room-img" :src="item.RoomImage" alt="">
									<div class="room-name">{{item.Name}}</div>
								</div>
								<div class="row flex-3">
									<div class="room-item sm-info" style='text-align:center;'>
										<span class="sm">功能：</span>
										<span v-html='item.RoomTypeLabel.replace(/\,/g,"<br>")'></span>
									</div>
									<div class="room-item sm-info"><span class="sm">面积：</span>{{item.Sqm}}</div>
									<div class="room-item sm-info"><span class="sm">容纳人数：</span>{{item.Capacity}}</div>
								</div>	
							</div>
							<div class="room-item flex-3" style='justify-content: flex-start'>
								<div class='desc' v-html='item.Description'></div>
							</div>
							<div class="room-item flex-2">
								<div class="date-select">
									<Checkbox :disabled='range.RoomStatus.toLowerCase() != "freeroom" || isPassed(date,range,serveTime) || date.getDay() == 0' v-for='range in item.ranges' :key='range.ID' class='checkbox' v-model='range.isChecked' @on-change="changeCheckbox(range,item)">{{range.BeginTime}} - {{range.EndTime}}</Checkbox>
								</div>
							</div>
							<div class="room-item flex-2">
								<div class="operation">
									<div class="price"><span class="sym">￥</span>{{item.Price}}</div>
									<Button @click='goCalendar(item)' type='primary' class='button'>查看日历</Button>
								</div>
							</div>
						</div>
					</div>
				</template>
				<div class='nodata' v-else>
					暂无可预约房间
				</div>
			</div>
		</div>
		<div class="footer">
			<Button :loading='loading' @click='goConfirm' size='large' type='primary' class="bottom-button">预约</Button>
		</div>
	</div>
</template>

<script>
	import MeetingHeader from '@/components/header/MeetingHeader'
	import util from '@/config/util'
	import loading from "@/components/order/loading";
	import {
		mapState,
		mapMutations,
		mapActions
	} from 'vuex'
	const now = new Date()
	const nowDate = new Date(now.getFullYear(),now.getMonth(),now.getDate())
	import {baseMixins} from './baseMixins'
	export default {
		data() {
			return {
				rooms:[],
				date:nowDate,
				loading:false,
				serveTime: new Date(),
				orderTime7: '',
				orderTime9: '',
				orderHour: '',
				options:{
					disabledDate:date=>{
						let now = this.serveTime
						now = new Date(now.getFullYear(),now.getMonth(),now.getDate())
						let diff = date.getTime() - now.getTime()
						if (diff < 0) return true
						if (date.getDay() == 0) return true
						let nextMonth = new Date(this.serveTime.getFullYear(),this.serveTime.getMonth() + 1,1)
						let next2Month = new Date(this.serveTime.getFullYear(),this.serveTime.getMonth() + 2,1)
						// 15号10点前不允许预约下月会议室
						if ((this.serveTime.getDate() < this.orderTime9 || this.serveTime.getDate() == this.orderTime9 && this.serveTime.getHours() < this.orderHour) && date >= nextMonth) return true
						if (date >= next2Month) return true
						return false
					}
				},
				checkRooms:[], // 存储被选中的会议信息
			}
		},
		created() {
			this.$nextTick(function() {
				this.initData()
			})
		},
		mounted() {

		},
		watch:{

		},
		mixins:[baseMixins],
		components: {
			MeetingHeader,
			loading,
		},
		computed: {
			...mapState({
				stores:state=>state.shmeeting.stores
			}),
			store() {
				return this.stores.filter(item=>item.StoreId == this.$route.query?.storeId)[0]
			}
		},
		methods: {
			...mapActions([
				'getMeetingRoomsAction',
				'getMeetingDurationsAction',
				'postReservationRoomsAction',
				'getStoresAction',
				'getUserRankAction',
				'getMeetingOrderTimeAction'
			]),
			async initData(){
				let StoreId = this.$route.query?.storeId
				this.date = await this.getServeTime()
				this.serveTime = this.date
				this.orderTime7 = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'rank7'})
				this.orderTime9 = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'rank9'})
				this.orderHour = await this.getMeetingOrderTimeAction({ParentCode: 'dt_ss_roomorder_time',Code: 'hour'})
				if (!StoreId){
					this.$router.replace('/meeting/start')
					return
				}
				this.loading = true
				if (!this.stores?.length) {
					await this.getStoresAction()
				}
				let rooms = await this.getMeetingRoomsAction({
					Date:util.formatDate.format(this.date,'yyyy-MM-dd'),
					StoreId
				})
				this.configRooms(rooms)
				this.loading = false
			},
			changeCheckbox(val,item) {
				let BookingDate = util.formatDate.format(this.date, 'yyyy-MM-dd');
				if (val.isChecked) {
					// 添加数据（避免重复）
					let exists = this.checkRooms.some(
						item => item.BookingDate == BookingDate && item.ID == val.ID && item.RoomId == val.RoomId
					);
					if (!exists) {
						this.checkRooms.push({ ...val,BookingDate:BookingDate,StoreName:item.StoreName,Price:item.Price,Amount:item.Price,OrderStatus:'UnPay',IsRoom:1 });
					}
				} else {
					// 过滤掉对应数据
					this.checkRooms = this.checkRooms.filter(
						item => !(item.BookingDate == BookingDate && item.ID == val.ID && item.RoomId == val.RoomId)
					);
				}
				sessionStorage.setItem('checkRooms', JSON.stringify(this.checkRooms));
			},
			async configRooms(rooms) {
				let StoreId = this.$route.query?.storeId
				let BookingDate = util.formatDate.format(this.date, 'yyyy-MM-dd');
				let ss_002 = await this.getMeetingDurationsAction({
					Date:BookingDate,
					StoreId
				})
				// 已选中的会议信息赋值
				ss_002.forEach(item => {
					item.isChecked = this.checkRooms.some(obj =>
						obj.BookingDate == BookingDate && obj.ID == item.ID && obj.RoomId == item.RoomId
					);
				});
				rooms.forEach(room=>room.ranges = ss_002.filter(item=>item.RoomId == room.ID))
				this.rooms = rooms
			},
			async dateChange(value,date){
				let rooms = await this.getMeetingRoomsAction({
					Date:value,
					StoreId:this.$route.query?.storeId
				})
				if (value) this.configRooms(rooms)
			},
			async goConfirm() {
				if (this.loading) return
				let Rooms = []
				let BookingDate = util.formatDate.format(this.date,'yyyy-MM-dd')
				let isPassed = false
				let nowServeTime = await this.getServeTime()
				this.rooms.forEach(room=>{
					let rooms = room.ranges.filter(item=>item.isChecked).map(item=>{
						if (!isPassed) {
							isPassed = this.isPassed(this.date,item,nowServeTime)
						}
						return {
							IsRoom:1,
							RoomId:item.RoomId,
							ProductId:0,
							Price:room.Price,
							Qty:1,
							Amount:room.Price,
							Discount:0,
							BookingDate,
							TimeRangeId:item.TimeRangeId,
						}
					})
					Rooms = [...Rooms,...rooms]
				})
				let Amount = Rooms.reduce((prev,cur)=>{
					return prev + cur.Price
				}, 0)
				let params = {
					StoreId:this.rooms[0].StoreId,
					OrderStatus:'UnPay',
					Amount,
					TotalPaid:Amount,
					Discount:0,
					Rooms,
					place:'list',
				}
				if (isPassed) {
					this.$Modal.info({
						title:'提示',
						content:"请勾选合适的日期时间"
					})
					return
				}
				if (!Rooms.length) {
					this.$Modal.info({
						title:'提示',
						content:"请勾选预约时间"
					})
					return
				}
				const result = await this.getUserRankAction()
				let now = await this.getServeTime()
				const [{Rank}] = result.data.value
				if ((this.date.getMonth() > nowDate.getMonth()) || (this.date.getMonth() === 0 && nowDate.getMonth() === 11)) {
					const checkCode = this.checkRank(Rank,this.orderTime9,this.orderTime7,this.orderHour,this.orderHour,now)
					if (checkCode === 0) {
							this.$Modal.info({
							title:'提示',
							content:`当前职级需${this.orderTime7}号${this.orderHour}点才能预约`
						})
						return
					}
				}
				this.$router.push(`/meeting/confirm?storeId=${this.$route.query?.storeId}`)
				return
				this.loading = true
				let response = await this.postReservationRoomsAction(params)
				this.loading = false
				if (typeof response?.Value == 'string') {
					this.$Modal.info({
						title:'提示',
						content:response?.Value,
					})
				} else if(response == -1) {
					this.$Modal.error({
						title:'错误',
						content:'提交异常，请稍后重试',
					})
				}  else {
					this.$router.push(`/meeting/confirm?code=${response?.Value}`)
				}
				
			},
			goCalendar(room){
				this.routerPush({
					path:'/meeting/calendar',
					query:{
						roomId:room.ID,
						storeId:room.StoreId,
					},
					params:{
						room,
					}
				})
			}
		},
	}
</script>

<style lang='scss' scoped>
	@import '@/style/mixin';
	.root {
		background-color: #eee;
	}
	.container {
		background-color: #eee;
		padding-top:1rem;
		margin:auto;
		max-width: 1400px;
		flex:1;
	}
	.sm {
		display:none;
	}
	.banner {
		display:flex;
		flex-direction: row;
		background-color: white;
		margin: 0 40px;
		border-radius: 20px;
		overflow: hidden;
		.banner-left {
			flex:5;
			max-height: 360px;
			.banner-img {
				object-fit: cover;
				width:100%;
				height:100%;
			}
		}
		.info {
			flex:3;
			margin-left: 40px;
			padding-top: 40px;
			.meeting-name {
				@include fontSize($font-size-22);
				font-weight: bold;
			}
			.meeting-desc {
				@include fontSize($font-size-16);
				margin-top: 10px;
			}
			.features {
				position:relative;
				display:grid;
				grid-template-columns: repeat(2, 50%);
  				grid-template-rows: repeat(2, 50%);
  				margin-top: 20px;
				.feature {
					display:flex;
					align-items: center;
					margin-top: 20px;
					@include fontSize($font-size-16);
					.icon {
						width:30px;
						height:30px;
						margin-right: 20px;
					}
				}
			}
		}
	}
	.content {
		margin: 10px 40px;
		.sh-date-picker-box {
			display:flex;
			flex-direction: row;
			justify-content: flex-end;
			margin:20px 0;
		}
		.table-heads {
			background-color: $theme-color;
			border-top-left-radius: 20px;
			border-top-right-radius: 20px;
			.table-head {
				flex:1;
				text-align: center;
				color:white;
				@include fontSize($font-size-18);
				padding:15px 0;
			}
		}
		.table-body {
			margin-top: 10px;
			.room {
				align-items: center;
				background-color: white;
			}
		}
		.room-item {
			flex:1;
			display:flex;
			justify-content: center;
			align-items: center;
			.room-img {
				width:150px;
				height:150px;
				object-fit: cover;
				border-radius: 10px;
				margin:10px 10px 0 10px;
			}
			.room-name {
				text-align: center;
				margin: 5px 0;
			}
			.desc {
				padding:10px
			}
			.date-select {
				padding:10px 0;
				position:relative;
				display:flex;
				flex-direction: column;
				align-items: center;
				.checkbox {
					margin-top: 5px;
				}
			}
			.operation {
				display:flex;
				flex-direction: column;
				align-items: center;
				.price {
					font-weight: bold;
					color:red;
					@include fontSize($font-size-30);
					.sym {
						@include fontSize($font-size-16);
					}
				}
				.button {
					width:100px;
					border-radius: 20px;
				}
			}
			
		}
		.row {
			display:flex;
			.flex-4 {
				flex:4;
			}
			.flex-3 {
				flex:3;
			}
			.flex-2 {
				flex:2;
			}
		}
	}
	.column {
		display:flex;
		flex-direction: column;
		align-items: center;
	}
	.footer {
		margin:20px auto 40px;
		.bottom-button {
			width:300px;
			border-radius: 30px;
		}
	}
	.nodata {
		background-color:white;
		padding:20px 0;
		text-align: center;
	}
	@media (max-width: 768px){
		.container {
			padding-top: 2.4rem;
		}
		.banner {
			flex-direction: column;
			margin: 0;
			.features {
				margin-bottom: 20px;
			}
			.info {
				margin-left: 10px;
				padding-top: 10px;
			}
		}
		.sm {
			display:inline;
		}
		.sm-info {
			padding-left: 10px;
			margin-bottom: 10px;
		}
		.content {
			margin: 10px 5px;
			margin-bottom: 50px;
			.table-body {
				.room {
					align-items: flex-start;
				}
			}
			.room-item {
				justify-content:flex-start;
				.room-img {
					border-radius: 10px;
					margin:10px 10px 0 10px;
				}
				.room-name {
					text-align: center;
				}
				.date-select {
					display:flex;
					flex-direction: row;
					justify-content: space-between;
					flex:1;
					margin:0 10px;
				}
				.desc {
					padding:10px;
				}
				.operation {
					flex-direction: row;
					justify-content: center;
					align-items: center;
					flex:1;
					padding-bottom: 20px;
					.price {
						font-size: 16px;
						margin-right: 15px;
					}

				}
			}
			.row {
				display:block;
			}
			.table-heads {
				display:none;
			}
		}
		.footer {
			position:fixed;
			bottom: 10px;
			width:100vw;
			margin:auto;
			text-align:center;
			.bottom-button {
				width:300px;
				border-radius: 30px;
			}
		}
	}
</style>